import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import ArcButton from '../ArcButton/arcButton';
import { ArcButtonGroupContextProvider } from '../../utils/buttonContext';
import groupStyle from './groupButton.module.scss';


function GroupButton(props) {
  const {
    options,
    value,
    style,
    unit,
    // resetGroupStyle,
  } = props;
  const [val, setVal] = useState(value);
  useEffect(() => {
    setVal(value);
  }, [value]);

  const onButtonChange = (e) => {
    setVal(e);
    const { onChange } = props;
    if (e !== val) {
      onChange(e);
    }
  };

  const renderGroup = () => options.map((item, index) => (
    <ArcButton
      key={item.key}
      id={item.key}
      text={item.text}
      checked={val === item.key}
      style={style}
      // style={{ ...style, marginTop: index > 1 ? '0.75rem' : 0 }}
      unit={unit}
      disabled={item.disable}
      isSpacing={index !== (options.length - 1)}
    >
      {item}
    </ArcButton>
  ));

  return (
    <ArcButtonGroupContextProvider value={{ onChange: onButtonChange }}>
      <div
        className={groupStyle['arc-group-button']}
        // style={{ ...resetGroupStyle, flexWrap: options.length > 2 ? 'wrap' : '' }}
      >
        {renderGroup()}
      </div>
    </ArcButtonGroupContextProvider>
  );
}

GroupButton.propTypes = {
  options: PropTypes.oneOfType([PropTypes.array]),
  onChange: PropTypes.func,
  unit: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.oneOfType([PropTypes.object]),
  // resetGroupStyle: PropTypes.objectOf(PropTypes.any),
};

GroupButton.defaultProps = {
  options: [], // 按钮文案数组
  onChange: () => {}, // 点击当前按钮事件
  value: '', // 绑定的值
  style: {},
  // resetGroupStyle: {},
  unit: 'rem',
};

export default GroupButton;
